import { TimelineLite, Elastic } from 'gsap/TweenMax';

import { qsa } from '@/scripts/utils';

export const uiIn = (el) => {
  const els = qsa('[data-anim]', el);

  const tl = new TimelineLite({ paused: true });

  tl
    .set(el, { autoAlpha: 1 })
    .staggerFrom(els, 1, {
      yPercent: 100,
      autoAlpha: 0,
      skewX: -20,
      ease: Elastic.easeOut.config(0.8, 1),
      clearProps: 'all',
    }, 0.2);

  return tl;
};

export const uiOut = (el) => {
  const els = qsa('[data-anim]', el);

  const tl = new TimelineLite({ paused: true });

  tl
    .staggerTo(els, 1, {
      yPercent: 100,
      autoAlpha: 0,
      skewX: -20,
      ease: Elastic.easeOut.config(0.8, 1),
      clearProps: 'all',
    }, 0.2)
    .set(el, { autoAlpha: 0 });

  return tl;
};



// WEBPACK FOOTER //
// ./src/scripts/timelines/uiTransitions.js